export default __webpack_public_path__ + "static/media/portrait.87e67163.glb";